import React from "react";

import SponsorDashboard from "./components/SponsorDashboard";
import Onboarding from "./Onboarding";

const SponsorHome: React.FC = () => (
  <>
    <Onboarding />
    <SponsorDashboard />
  </>
);

export default SponsorHome;
